import { components } from "@/api-schema";

type Vehicle = components["schemas"]["Vehicle"];

/**
 * Resolves the customer-facing model name for a vehicle, mirroring the FAB fallback:
 * modelDescription -> modelGeneration.name -> modelGeneration.modelFamily.name.
 */
export function getVehicleModelName(
  vehicle?: Pick<Vehicle, "modelDescription" | "modelGeneration"> | null,
): string | undefined {
  return (
    vehicle?.modelDescription ||
    vehicle?.modelGeneration?.name ||
    vehicle?.modelGeneration?.modelFamily?.name ||
    undefined
  );
}
